export const ACCESS_TOKEN_KEY = 'accessToken';
export const CLIENT_UUID_KEY = 'client_uuid';

export const PATHS = {
    auth: '/auth',
    billing: '/workspaces/:workspaceId/billing',
    subscription: '/workspaces/:workspaceId/billing/subscription',
    bot: '/bot',
    bots: '/workspaces/:workspaceId/bots',
    card: '/workspaces/:workspaceId/card',
    collections: '/workspaces/:workspaceId/collections',
    contacts: '/workspaces/:workspaceId/contacts',
    conversations: '/workspaces/:workspaceId/conversations',
    integrations: '/workspaces/:workspaceId/integrations',
    messages: '/workspaces/:workspaceId/conversations/:contactId/messages',
    onboarding: '/workspaces/:workspaceId/onboarding',
    products: '/workspaces/:workspaceId/products',
    crm: '/workspaces/:workspaceId/crm',
    endpoints: '/workspaces/:workspaceId/endpoints',
    services: '/workspaces/:workspaceId/services',
    replies: '/workspaces/:workspaceId/replies',
    websites: '/workspaces/:workspaceId/websites',
    website: '/workspaces/:workspaceId/websites/:websiteId',
    pages: '/workspaces/:workspaceId/websites/:websiteId/pages',
    feedbacks: '/workspaces/:workspaceId/websites/:websiteId/feedback',
    blocks: '/workspaces/:workspaceId/websites/:websiteId/pages/:pageId/blocks',
    orders: '/workspaces/:workspaceId/orders',
    tags: '/workspaces/:workspaceId/tags',
    templates: '/workspaces/:workspaceId/templates',
    team: '/workspaces/:workspaceId/team',
    users: '/users',
    invites: '/workspaces/:workspaceId/invites',
    workspaces: '/workspaces',
};
